module.exports = __webpack_public_path__ + "img/activeforms.bd170d5d.png";